// extracted by mini-css-extract-plugin
export var feature = "ProFeatureComparisonTable-module__feature___jbD2Y";
export var features = "ProFeatureComparisonTable-module__features___SH5Dc";
export var head = "ProFeatureComparisonTable-module__head___D66_Q";
export var newBadge = "ProFeatureComparisonTable-module__newBadge___QyVNB";